<template>
  <div class="publicMain">
    <div v-if="dataList.length" class="scorllBox" :style="{
      width: dataList.length * 240 - 20 + 'px',
    }">
      <div class="item" v-for="(item, index) in dataList" :key="'data_' + index" @click="getInfo(item.id)">
        <div class="name">{{ item.gsmc }}</div>
        <div class="time">发布时间：{{ "2010-01-01" }}</div>
      </div>
    </div>

    <div v-if="vLoading" style="width: 100%; height: 100px; text-align: center; margin-top: 40px">
      <van-loading size="30px">加载中...</van-loading>
    </div>
    <div class="content" v-if="!vLoading && !dataList.length">
      <div class="top">
        <img class="image" src="../../assets/img/img_toupiao_nodata.png" alt="" />
      </div>
      <div class="footer">
        <p class="nodata">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/home.js'
export default {
  props: {
    wyqyId: Number,
  },
  data() {
    return {
      dataList: [],
      vLoading: true
    };
  },
  created() {
    this.wyqyId = sessionStorage.getItem('wyqy')

  },
  mounted() {
    // this.getList()
  },
  methods: {
    getList() {

      let params = {
        gslx: 0,
        openId: sessionStorage.getItem('openId'),
        wyqyId: Number(this.wyqyId)
      }
      this.vLoading = true
      api.homeGsList(params).then(res => {
        if (res.data.code == 200 && res.data.data) {
          this.dataList = res.data.data.splice(0, 3)
          this.vLoading = false
        } else {
          this.vLoading = false

        }

      }).catch(err => {
        this.vLoading = false

      })
    },
    getInfo(id) {

    }
  },

  watch: {},
};
</script>

<style lang="less" scoped>
.publicMain {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;

  &::-webkit-scrollbar {
    width: 1px;
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  &::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    clear: both;
  }

  .scorllBox {
    height: 100%;
    width: 200%;
  }

  .item {
    padding: 16px;
    width: 220px;
    background-color: #fff;
    height: 126px;
    border-radius: 3px;
    float: left;

    &+.item {
      margin-left: 20px;
    }

    .name {
      color: #222120;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
    }

    .time {
      display: inline-block;
      font-size: 12px;
      color: #999998;
      background-color: #f7f7f7;
      padding: 3px 10px;
      margin-top: 16px;
      line-height: 24px;
    }
  }
}

.content {
  // height: 100%;

  .top {
    width: 180px;
    height: 200px;
    padding: 15px;
    position: relative;
    top: 10px;
    left: 50%;
    margin-left: -100px;
    text-align: center;
    // border: 1px dashed #4e4d4d;

    .image {
      width: 100%;
      // border: 1px dashed #4e4d4d;
    }

    .nadata {
      margin-top: 20px;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: #4e4d4d !important;
    }
  }

  .footer {
    width: 100%;
    height: 33px;
    text-align: center;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #4e4d4d !important;
  }
}
</style>
